import { ChangeDetectionStrategy, Component, computed } from '@angular/core';

import type { FormButtonSettingsData } from '@sites/entity-core';
import type { PaymentFormWidgetForm } from '@sites/entity-signal-form';

import { CommonElementsModule } from '@web/widgets/common/common-elements.module';
import { SpFormButtonSettingsSignalComponent } from '@components/sp-form-button-settings-signal';
import { isEmptyButtonLabel } from '@common/helpers';
import { FormSettingsPanel } from '@web/widgets/common/abstract/form-settings-panel';

/**
 * Breadcrumbs/footer chrome around `sp-form-button-settings-signal`, writing
 * straight into the payment-form signal form. Save/cancel and the transaction
 * frame come from `FormSettingsPanel`.
 */
@Component({
    selector: 'web-payment-button-settings',
    templateUrl: './payment-button-settings.component.html',
    styleUrls: ['./payment-button-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonElementsModule, SpFormButtonSettingsSignalComponent],
})
export class PaymentButtonSettingsComponent extends FormSettingsPanel<PaymentFormWidgetForm> {
    public readonly settings = computed<FormButtonSettingsData>(() => this.form().formButtonSettings().value());

    public onSettingsChange(value: FormButtonSettingsData): void {
        this.form().setFormButtonSettings(value);
    }

    public override get saveDisablePredicate(): boolean {
        return isEmptyButtonLabel(this.settings()?.label);
    }
}
